import DataAccess from './constants';
import API from './API'
const path = 'customerudfs';

let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const UpdateCustomerUdfs = (customer) => {

    return api.putData(path, customer);
}

export const GetCustomersUdfs = (customer) => {
    let newpath = path + "?CustomerIDList=" + customer.customerIdList;
    return api.getData(newpath)
}